module.exports = __webpack_public_path__ + "img/project15_5.jpeg.5f2a98b1.webp";